export default "__VITE_ASSET__w4uXjTR___"